import axios from '@/libs/axios'

export default {
  byStartAt: () => axios.get('/order/statistics/count-by-start-at'),
  financialResultsByOrder: month => axios.get(`/order/statistics/financial-results-by-order/${month}`),
}
